import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';

interface TimePeriodButtonProps {
  selected: boolean;
  firstIcon: IconDefinition | IconProp | undefined;
  middleIcon: IconDefinition | IconProp | undefined;
  lastIcon: IconDefinition | IconProp | undefined;
  firstLine: string | undefined;
  secondLine: string | undefined;
  timePeriod: string | undefined;
  onClick: () => unknown;
}
const TimePeriodButton: React.FC<TimePeriodButtonProps> = ({
  selected,
  firstIcon,
  middleIcon,
  lastIcon,
  firstLine,
  secondLine,
  timePeriod,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={`selection-button${selected ? ' selected' : ''}`}
    >
      <div className="button-container">
        <div className="icon-container">
          {firstIcon && (
            <FontAwesomeIcon
              icon={firstIcon}
              size="2x"
              className="first icon"
            />
          )}
          {middleIcon && (
            <FontAwesomeIcon
              icon={middleIcon}
              size="2x"
              className="middle icon"
            />
          )}
          {lastIcon && (
            <FontAwesomeIcon icon={lastIcon} size="2x" className="last icon" />
          )}
        </div>
        {firstLine && <div className="text">{firstLine}</div>}
        {secondLine && <div className="small-text">{secondLine}</div>}
      </div>
      {timePeriod && (
        <div className="small-text date-time-period">{timePeriod}</div>
      )}
    </button>
  );
};

export default TimePeriodButton;
